"use client";

import { Box, type BoxProps } from "@mui/material";

type QrCardProps = BoxProps & {
    radius?: number;
    borderWidth?: number;
};

export default function QrCard({
    radius = 14,
    borderWidth = 0.95,
    sx,
    children,
    ...rest
}: QrCardProps) {
    const stroke = `${borderWidth}px`;

    return (
        <Box
            sx={{
                position: "relative",
                borderRadius: `${radius}px`,
                height: "100%",
                backgroundColor: "#15151559",
                overflow: "hidden",
                transition: "background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                    backgroundColor: "#141414",
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.45)",
                },
                "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: `${radius}px`,
                    padding: stroke,
                    background:
                        "linear-gradient(180deg, rgba(47,47,47,0.61) 0%, rgba(149,149,149,0.40) 100%)",
                    WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
                    WebkitMaskComposite: "xor",
                    maskComposite: "exclude",
                    pointerEvents: "none",
                    zIndex: 2,
                },
                ...sx,
            }}
            {...rest}
        >
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    height: "100%",
                    width: "100%",
                    p: 3,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
